class ProductCertificateMultiCard extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-pc-filter]'));
    this.groups = Array.from(this.querySelectorAll('[data-pc-group]'));
    this.groupsWrap = this.querySelector('[data-pc-groups]');
    this._spyKey = 'all';

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.filter(tab.dataset.pcFilter));
      tab.addEventListener('keydown', (e) => this.onKey(e));
    });

    this.querySelectorAll('[data-ph-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => this.toggleCert(e.currentTarget));
    });

    // scroll-spy: while in "All", highlight the chip of the report currently at the top
    if (this.groupsWrap) {
      this.groupsWrap.addEventListener('scroll', () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => { this._raf = null; this.spy(); });
      }, { passive: true });
    }
  }

  setActiveChip(key) {
    this.tabs.forEach((tab) => {
      const on = tab.dataset.pcFilter === key;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
  }

  scrollChipIntoView(key) {
    const chip = this.tabs.find((t) => t.dataset.pcFilter === key);
    if (chip) chip.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  }

  // clicking a chip: "All" = show every report (scrollable); a report = isolate it
  filter(key) {
    this.setActiveChip(key);
    const showAll = key === 'all';
    if (this.groupsWrap) this.groupsWrap.classList.toggle('is-all', showAll);

    this.groups.forEach((group) => {
      const show = showAll || group.dataset.pcGroup === key;
      if (show) group.removeAttribute('hidden');
      else group.setAttribute('hidden', '');
    });

    if (showAll && this.groupsWrap) {
      this.groupsWrap.scrollTop = 0;
      this._spyKey = 'all';
    }
    this.scrollChipIntoView(key);
  }

  spy() {
    if (!this.groupsWrap || !this.groupsWrap.classList.contains('is-all')) return;
    const top = this.groupsWrap.scrollTop;
    const threshold = 24;
    let key = 'all';
    this.groups.forEach((g) => {
      if (g.offsetTop <= top + threshold) key = g.dataset.pcGroup;
    });
    if (top <= 4) key = 'all';
    if (key === this._spyKey) return;
    this._spyKey = key;
    this.setActiveChip(key);
    this.scrollChipIntoView(key);
  }

  onKey(e) {
    const last = this.tabs.length - 1;
    const i = this.tabs.findIndex((t) => t.classList.contains('is-active'));
    let n = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = i === last ? 0 : i + 1;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = i === 0 ? last : i - 1;
    if (e.key === 'Home') n = 0;
    if (e.key === 'End') n = last;
    if (n === null) return;
    e.preventDefault();
    this.filter(this.tabs[n].dataset.pcFilter);
    this.tabs[n].focus();
  }

  toggleCert(btn) {
    const block = btn.closest('.product-certificate-certificate');
    const preview = block ? block.querySelector('[data-ph-preview]') : null;
    if (!preview) return;
    const isHidden = preview.hasAttribute('hidden');
    if (isHidden) {
      preview.removeAttribute('hidden');
      btn.textContent = btn.dataset.hideLabel;
      btn.setAttribute('aria-expanded', 'true');
    } else {
      preview.setAttribute('hidden', '');
      btn.textContent = btn.dataset.showLabel;
      btn.setAttribute('aria-expanded', 'false');
    }
  }
}

if (!customElements.get('product-certificate-multi-card')) {
  customElements.define('product-certificate-multi-card', ProductCertificateMultiCard);
}
